// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rootuser svg {
    height: 32px;
    width: 32px;
}

.root_sidebar_icon svg {
    height: 18px;
    width: 18px;
    color: white;
    stroke: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/RootUser/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".rootuser svg {\n    height: 32px;\n    width: 32px;\n}\n\n.root_sidebar_icon svg {\n    height: 18px;\n    width: 18px;\n    color: white;\n    stroke: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
